export default {
  stickyButtonTotal: {
    id: 'go_to_next_sticky_button_recap_total',
    defaultMessage: 'Cart total',
  },
  stickyPriceDueToday: {
    id: 'cart_sticky_price_title_due_today',
    defaultMessage: 'due today',
  },
  priceAfterTradeIn: {
    id: 'cart_sticky_price_title_after_trade_in',
    defaultMessage: '({price} after trade-in)',
  },
  tvaIncluded: {
    id: 'go_to_next_tva_included',
    defaultMessage: 'VAT included',
  },
}
